export class App {
  scaleMin:number = 1;
  scaleMax:number = 3;
  constructor(public skills:Array<Skill>, public poles:Array<Pole>)
  {
  }
  getPoleScale(pole:Pole):number
  {
    let ret = this.scaleMin;
    if (this.skills.length != 0){
      ret = this.scaleMin + (this.scaleMax - this.scaleMin) * pole.skills.length/this.skills.length;
    }
    return ret;
  }
}
export class Skill {
  text:string;
  image:string;
}
export class Pole {
  title:string;
  color:string;
  skills:Array<Skill>;
}
